import { File, FileText, Film, Image, Link2 } from 'lucide-react';
import { mediaKindOf } from './uploadedMedia';

/** The kind of a file as an icon, for files with no thumbnail. */
export function MediaKindIcon({
  media,
  className
}: {
  media: { name: string; mimeType?: string };
  className?: string;
}) {
  switch (mediaKindOf(media)) {
    case 'image':
      return <Image className={className} aria-hidden />;
    case 'video':
      return <Film className={className} aria-hidden />;
    case 'pdf':
      return <FileText className={className} aria-hidden />;
    case 'link':
      return <Link2 className={className} aria-hidden />;
    case 'other':
      return <File className={className} aria-hidden />;
  }
}
